import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { SectionHeader } from '../ui/SectionHeader';
import styles from './AboutSection.module.css';

export const AboutSection = () => {
  const { t } = useTranslation();
  const [ref, visible] = useScrollReveal(0.1);

  const highlights = [
    {
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
      title: t('about.highlights.research'),
      desc: t('about.highlights.research_desc'),
    },
    {
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: t('about.highlights.transfer'),
      desc: t('about.highlights.transfer_desc'),
    },
    {
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      title: t('about.highlights.innovation'),
      desc: t('about.highlights.innovation_desc'),
    },
  ];

  return (
    <section id="about" ref={ref as React.RefObject<HTMLElement>} className={styles.section}>
      <div className="container">
        <SectionHeader label={t('about.label')} title={t('about.title')} />

        <div className={`${styles.mainLayout} ${visible ? styles.visible : ''}`}>
          {/* Left Column: Graphic Representation of the Mountains */}
          <div className={styles.graphicColumn}>
            <div className={styles.imageCard}>
              <div className={styles.topographyOverlay}>
                <div className={styles.coordinateLabel}>LAT 42.4694° N / LON 13.5653° E</div>
                <div className={styles.altitudeLabel}>GRAN SASSO D'ITALIA • 2,912 m</div>
              </div>
              <img
                src="/images/gran_sasso_valley.png"
                alt="Gran Sasso Valley Digital Mesh"
                className={styles.topographyImage}
                loading="lazy"
              />
              <div className={styles.imageGlow} />
              <div className={styles.cornerIndicatorTop} />
              <div className={styles.cornerIndicatorBottom} />
            </div>
          </div>

          {/* Right Column: Story Narrative and highlights */}
          <div className={styles.contentColumn}>
            <div className={styles.narrative}>
              <p className={styles.paragraph}>{t('about.paragraph1')}</p>
              <p className={styles.paragraph}>{t('about.paragraph2')}</p>
            </div>

            <div className={styles.highlightsList}>
              {highlights.map((h, idx) => (
                <div
                  key={idx}
                  className={styles.highlightCard}
                  style={{ transitionDelay: `${idx * 100}ms` }}
                >
                  <div className={styles.highlightIconContainer}>{h.icon}</div>
                  <div className={styles.highlightText}>
                    <h3 className={styles.highlightTitle}>{h.title}</h3>
                    <p className={styles.highlightDesc}>{h.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
